import { render } from "./UiBaseMenuDropdown.vue?vue&type=template&id=06ba6fea"
import script from "./UiBaseMenuDropdown.vue?vue&type=script&lang=js"
export * from "./UiBaseMenuDropdown.vue?vue&type=script&lang=js"

import "./UiBaseMenuDropdown.vue?vue&type=style&index=0&id=06ba6fea&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__